import { Clickout } from '../actions'
import { analytics } from './lib'
import {
  ProviderLink,
  type ProviderLinkProperties,
  type ProviderWidgetProperties,
} from '../objects/ProviderLink'

export function ProviderLinkClickout(
  slug: string,
  widget: ProviderWidgetProperties,
  link: ProviderLinkProperties,
) {
  return analytics(new Clickout(), new ProviderLink({ provider: { slug, widget, link } }))
}
